import { Reveal, Eyebrow } from "./Reveal";

const PILLARS = [
  ["Music", "Records built to replay."],
  ["Videos", "Visuals that hit as hard as the beat."],
  ["Artists", "A camp that moves together."],
];

export const Label = () => (
  <section id="label" data-testid="label-section" className="relative overflow-hidden border-y border-[var(--line)] bg-[var(--bone)] px-4 py-24 text-[var(--ink)] sm:px-8 sm:py-32 lg:px-16">
    <img src="/mae-logo.webp" alt="" aria-hidden className="pointer-events-none absolute -right-40 top-1/2 w-[640px] -translate-y-1/2 opacity-[0.08] animate-spin-slow" />
    <div className="relative mx-auto max-w-7xl">
      <Reveal>
        <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-zinc-600">
          <span>04</span><span className="h-px w-10 bg-zinc-600" /><span>The label</span>
        </div>
        <h2 className="mt-8 max-w-5xl font-display text-5xl uppercase leading-[0.92] sm:text-7xl lg:text-8xl">
          Money <span className="font-serif-i normal-case">always</span> comes from the music.
        </h2>
      </Reveal>
      <div className="mt-16 grid gap-px overflow-hidden rounded-[28px] border border-[rgba(7,7,7,0.15)] bg-[rgba(7,7,7,0.15)] md:grid-cols-3">
        {PILLARS.map(([t, d], i) => (
          <Reveal key={t} delay={i * 0.1} className="bg-[var(--bone)] p-8 sm:p-10">
            <p className="font-mono text-xs text-zinc-600">0{i + 1}</p>
            <h3 className="mt-10 font-display text-4xl uppercase">{t}</h3>
            <p className="mt-3 text-zinc-700">{d}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export { Eyebrow };
